const base = (state) => state.workkardForm?.address || {};


export const selectCountries = (section) => (state) =>
  base(state).countries?.[section]?.data || [];

export const selectCountriesLoading = (section) => (state) =>
  Boolean(base(state).countries?.[section]?.loading);

export const selectCountriesLoaded = (section) => (state) =>
  Boolean(base(state).countries?.[section]?.loaded);

export const selectCountriesError = (section) => (state) =>
  base(state).countries?.[section]?.error || null;


export const selectStates = (section) => (state) =>
  base(state).states?.[section]?.data || [];

export const selectStatesLoading = (section) => (state) =>
  Boolean(base(state).states?.[section]?.loading);

export const selectStatesCountry = (section) => (state) =>
  base(state).states?.[section]?.country || null;


export const selectZipLookupLoading = (state) => Boolean(base(state).zipLookup?.loading);
export const selectZipLookupError = (state) => base(state).zipLookup?.error || null;
export const selectZipLookupResult = (state) => base(state).zipLookup?.lastResult || null;
